import { useMemo } from 'react';

export const useEnum = () => {
    const ECommerceType = {
        Amazon: 1,
        Shopee: 2,
        Lazada: 3,
    };

    return {
        ECommerceType,
    };
};

export const useOptions = () => {
    const { ECommerceType } = useEnum();

    const ECommerceTypeOptions = useMemo(() => {
        return [
            {
                value: ECommerceType.Amazon,
                label: 'Amazon',
            },
            // {
            //     value: ECommerceType.Shopee,
            //     label: 'Shopee',
            // },
            // {
            //     value: ECommerceType.Lazada,
            //     label: 'Lazada',
            // },
        ];
    }, [ECommerceType]);

    return {
        ECommerceTypeOptions,
    };
};

export const getLabel = (
    options: { label: string; value: number | string }[],
    v: number | string
) => {
    return options.find((o) => o.value === v)?.label ?? '-';
};
